const SIZE_GUIDES_TABLE = {
  columns: [
    {
      key: 'size',
      title: 'Brand’s Size',
      titleKey: 'SIZE_GUIDES_POMELO_SIZE',
    },
    {
      key: 'xs',
      title: 'XS 25',
      titleKey: 'SIZE_GUIDES_SIZE_XS',
    },
    {
      key: 's',
      title: 'S 26,27',
      titleKey: 'SIZE_GUIDES_SIZE_S',
    },
    {
      key: 'm',
      title: 'M 28,29',
      titleKey: 'SIZE_GUIDES_SIZE_M',
    },
    {
      key: 'l',
      title: 'L 30,31',
      titleKey: 'SIZE_GUIDES_SIZE_L',
    },
    {
      key: 'xl',
      title: 'XL 32,33',
      titleKey: 'SIZE_GUIDES_SIZE_XL',
    },
    {
      key: 'xxl',
      title: 'XXL 34',
      titleKey: 'SIZE_GUIDES_SIZE_XXL',
    },
  ],
  rows: [
    {
      size: 'UK',
      xs: '6',
      s: '8',
      m: '10',
      l: '12',
      xl: '14',
      xxl: '16',
    },
    {
      size: 'US',
      xs: '2',
      s: '4',
      m: '6',
      l: '8',
      xl: '10',
      xxl: '12',
    },
    {
      size: 'FR',
      xs: '34',
      s: '36',
      m: '38',
      l: '40',
      xl: '42',
      xxl: '44',
    },
    {
      size: 'IT',
      xs: '38',
      s: '40',
      m: '42',
      l: '44',
      xl: '46',
      xxl: '48',
    },
    {
      size: 'AU',
      xs: '6',
      s: '8',
      m: '10',
      l: '12',
      xl: '14',
      xxl: '16',
    },
  ],
}

const SIZE_GUIDES_INFO = {
  title: {
    titleKey: 'SIZE_GUIDES_TITLE',
    default: 'How to measure',
  },
  description: {
    titleKey: 'SIZE_GUIDES_DESCRIPTION',
    default:
      'Use a measuring tape follow this guide to find your perfect fit. These measurements should be taken directly on your body.',
  },
  sizeGuide: {
    titleKey: 'PDP_SIZE_GUIDE_LABEL',
    default: 'Size Guide',
  },
  unitTitle: {
    titleKey: 'SIZE_GUIDES_UNITS_TITLE',
    default: 'International sizing (inch)',
  },
  newSizeTitle: {
    titleKey: 'SIZE_GUIDES_NEW_MARK_TITLE',
    default: 'Pomelo New Size Guide!',
  },
  newSizeDescription: {
    titleKey: 'SIZE_GUIDES_NEW_MARK_DESCRIPTION',
    default:
      'Starting from 2022, we will update our size guide to based on body measurement and size may run smaller than before. Please check our new size guide before purchase.',
  },
}

const SIZE_GUIDES_IMAGE_URL = '/img/measurement_guide/pdp-measurement.png'

const SIZE_GUIDES_TABLE_NEWSIZE = {
  columns: [
    {
      key: 'size',
      title: 'Brand’s Size',
      titleKey: 'SIZE_GUIDES_POMELO_SIZE',
    },
    {
      key: 'xxs',
      title: 'XXS 25',
      titleKey: 'SIZE_GUIDES_NEWSIZE_XXS',
    },
    {
      key: 'xs',
      title: 'XS 26-27',
      titleKey: 'SIZE_GUIDES_NEWSIZE_XS',
    },
    {
      key: 's',
      title: 'S 28-29',
      titleKey: 'SIZE_GUIDES_NEWSIZE_S',
    },
    {
      key: 'm',
      title: 'M 30-31',
      titleKey: 'SIZE_GUIDES_NEWSIZE_M',
    },
    {
      key: 'l',
      title: 'L 32-33',
      titleKey: 'SIZE_GUIDES_NEWSIZE_L',
    },
    {
      key: 'xl',
      title: 'XL 34',
      titleKey: 'SIZE_GUIDES_NEWSIZE_XL',
    },
  ],
  rows: [
    {
      size: 'UK',
      xxs: '6',
      xs: '8',
      s: '10',
      m: '12',
      l: '14',
      xl: '16',
    },
    {
      size: 'US',
      xxs: '2',
      xs: '4',
      s: '6',
      m: '8',
      l: '10',
      xl: '12',
    },
    {
      size: 'FR',
      xxs: '34',
      xs: '36',
      s: '38',
      m: '40',
      l: '42',
      xl: '44',
    },
    {
      size: 'IT',
      xxs: '38',
      xs: '40',
      s: '42',
      m: '44',
      l: '46',
      xl: '48',
    },
    {
      size: 'AU',
      xxs: '6',
      xs: '8',
      s: '10',
      m: '12',
      l: '14',
      xl: '16',
    },
  ],
}

const SHOE_TABLE_HEADER = {
  key: 'size',
  title: 'Measurements',
  titleKey: 'SIZE_GUIDES_SHOE_SIZE',
}

export {
  SIZE_GUIDES_TABLE,
  SIZE_GUIDES_IMAGE_URL,
  SIZE_GUIDES_INFO,
  SIZE_GUIDES_TABLE_NEWSIZE,
  SHOE_TABLE_HEADER,
}
